<template>
  <div class="system-builder__configure-system--vehicle-container">
    <p>What is your vehicle's year, make and model?</p>

    <div v-if="sharedState.vehicleMakesData.length < 1">
      <spinner size="large" message="Loading Vehicle list..."></spinner>
    </div>

    <div v-else>
      <div class="select-button-style">
        <div class="arrow-button"></div>
        <select ref="makesSelection" id="vehicle-make" name="vehicle-make" v-model="sharedState.selectedMake"
                @change="getVehicleModels">
          <option :value="sharedState.selectedMake" selected disabled>{{sharedState.selectedMake}}</option>
          <option disabled>_____________</option>
          <option v-for="make in sharedState.vehicleMakesData" v-bind:value="make">{{ make }}</option>
        </select>
      </div>

      <div class="select-button-style">
        <div class="arrow-button"></div>
        <select id="vehicle-model" name="vehicle-model" v-model="sharedState.selectedModel"
                @change="getVehicleYears">
          <option :value="sharedState.selectedModel" selected disabled>{{sharedState.selectedModel}}</option>
          <option disabled>_____________</option>
          <option v-for="model in sharedState.vehicleModelsData" v-bind:value="model">{{ model }}</option>
        </select>
      </div>

      <div class="select-button-style">
        <div class="arrow-button"></div>
        <select id="vehicle-year" name="vehicle-year" v-bind:data-id="sharedState.selectedYear"
                v-model="sharedState.selectedYear" @change="updateVehicleObjectState">
          <option :value="sharedState.selectedYear" :data-year="sharedState.selectedYearValue" selected disabled>
            {{sharedState.vehicleObject.year}}
          </option>
          <option disabled>_____________</option>
          <option v-for="item in sharedState.vehicleYearsData" v-bind:value="item.id">{{ item.year }}</option>
        </select>
      </div>
    </div>

    <transition name="fade" v-if="successNotification">
      <div class="vehicle-compatible-message">
        Your vehicle is compatible!
      </div>
    </transition>

    <transition name="fade" v-else-if="warningNotification">>
      <div class="vehicle-incompatible-message">
        <strong>Your vehicle may not be compatible.</strong>
        <p>We recommend contacting your local retailer.</p>
      </div>
    </transition>

    <transition name="fade" v-if="sharedState.showVehicleContinueButton === false">
      <spinner size="medium" message="Loading system components..."></spinner>
    </transition>

    <transition name="fade" v-if="sharedState.steps.selectVehicle.passedValidation && sharedState.showVehicleContinueButton">
      <footerNav></footerNav>
    </transition>
  </div>
</template>

<script>
  import store from '../../store/index'
  import axios from 'axios'
  import spinner from 'vue-simple-spinner'
  import footerNav from '../reusable/stickyFooterNavigation.vue'

  export default {
    components: {spinner, footerNav},
    name: 'selectVehicle',
    data () {
      return {
        sharedState: store.state,
        successNotification: false,
        warningNotification: false
      }
    },
    methods: {
      // TODO: Loading on button if remote request is still in progress

      updateVehicleObjectState: function (event) {
        this.vehicleId = event.target.value

        store.updateVehicleObject(this.sharedState.selectedMake, this.sharedState.selectedModel, event.target.value)
        store.updateCurrentStepValidation(true)

        // Display message depending on vehicle compatibility
        if (this.sharedState.vehicleObject.compatibleSystem === false || this.sharedState.vehicleObject.compatibleSystem === 'FALSE') {
          this.successNotification = false
          this.warningNotification = true
        } else if (this.sharedState.vehicleObject.compatibleSystem === null || this.sharedState.vehicleObject.compatibleSystem === '') {
          this.warningNotification = false
          this.successNotification = true
        }
      },
      cleanArray: function (arr) {
        return arr.filter(function (x, i) {
          return arr.indexOf(x) === i
        })
      },
      separateYearArray: function (originalArray) {
        var automaticYears = []
        var manualYears = []
        var value

        for (var i = 0; i < originalArray.length; i++) {
          value = originalArray[i]['trany']

          if (value === 'Automatic') {
            automaticYears.push(originalArray[i])
          } else {
            manualYears.push(originalArray[i])
          }
        }

        // Send manual transmission array state
        store.updateManualYears(manualYears)

        return automaticYears
      },
      getVehicleMakes: function () {
        var makesArr = []
        var vehicleMakes = this.sharedState.vehicleJson.makes[0]

        for (var i in vehicleMakes) {
          makesArr.push(i)
        }

        // Clean make array
        makesArr = this.cleanArray(makesArr)
        makesArr = makesArr.sort()

        return makesArr
      },
      getVehicleModels: function (event) {
        var makeValue = event.target.value
        var vehicleMakes = this.sharedState.vehicleJson.makes[0]
        var modelArray = []

        for (var i in vehicleMakes) {
          if (i === makeValue) {
            var vehicleMake = vehicleMakes[i]
            for (var x in vehicleMake) {
              modelArray.push(vehicleMakes[i][x]['model'])
            }
          }
        }

        // Strip model array of duplicate values and sort
        modelArray = this.cleanArray(modelArray)
        modelArray = modelArray.sort()

        // Set Year data to empty array
        this.sharedState.vehicleYearsData = []

        // Remove selected year
        this.sharedState.selectedYear = 'Vehicle Year'
        this.sharedState.selectedYearValue = 'Vehicle Year'
        this.sharedState.vehicleObject.year = 'Vehicle Year'

        // Remove selected model
        this.sharedState.selectedModel = 'Vehicle Model'

        this.sharedState.vehicleModelsData = modelArray
      },
      getVehicleYears: function (event) {
        var makeValue = this.sharedState.selectedMake
        var modelValue = event.target.value
        var yearArray = []
        var vehicleMakes = this.sharedState.vehicleJson.makes[0]

        for (var i in vehicleMakes) {
          if (i === makeValue) {
            var vehicleMake = vehicleMakes[i]
            for (var x in vehicleMake) {
              if (vehicleMakes[i][x]['model'] === modelValue) {
                yearArray.push({
                  year: vehicleMakes[i][x]['year'],
                  id: vehicleMakes[i][x]['id'],
                  trany: vehicleMakes[i][x]['trany'],
                  compatibleSystem: vehicleMakes[i][x]['compatibleSystem'],
                  vehicleSpecificId: vehicleMakes[i][x]['vehicleSpecificId']
                })
              }
            }
          }
        }

        // Clean duplicate year values
        yearArray = this.separateYearArray(yearArray)
        yearArray = yearArray.sort(function (a, b) {
          return b.year - a.year
        })

        this.sharedState.vehicleYearsData = yearArray
      },
      getVehicleData: function () {
        var host = 'https://' + window.location.hostname
        var themePath = '/wp-content/themes/arcticstart_ch/javascript/'

        var jsonPath = host + themePath + 'vehicles.json'

        axios.get(jsonPath).then((response) => {
          store.holdVehicleJson(response.data)
          this.sharedState.vehicleJson = response.data
          this.sharedState.vehicleMakesData = this.getVehicleMakes()
        }).catch(error => {
          console.log(error)
        })
      }
    },
    created: function () {
      if (this.sharedState.vehicleJson === null) {
        this.getVehicleData()
      }
      store.getLocalStorage()
    }
  }
</script>



// WEBPACK FOOTER //
// SelectVehicle.vue?000a9b1e